import HeroSection from "../components/HeroSection";
import Meta from "../components/Meta";
import StructuredData from "../components/StructuredData";
import RichText from "../components/RichText";
import PreviewBanner from "../components/PreviewBanner";
import { getCompanyInfo } from "../lib/queries/getCompanyInfo";
import { getPageContent } from "../lib/queries/getPageContent";
import { getPersonnel } from "../lib/queries/getPersonnel";
import PersonnelSection from "../components/personnelSection";

export default function Meista({
  companyInfo,
  pageContent,
  personnel,
  preview,
}) {
  return (
    <>
      <Meta pageContent={pageContent} />
      <StructuredData />
      <div id="content">
        {preview && <PreviewBanner />}
        {pageContent.hero && (
          <section>
            <HeroSection content={pageContent.hero} />
          </section>
        )}
        <section className="page-section page-content">
          <div className="page-width md:flex md:gap-12">
            <div className="md:w-1/2 mb-8 md:mb-0">
              {!pageContent.hero && (
                <h2 className="section-heading">{pageContent.title}</h2>
              )}
              <RichText className="text-block" value={pageContent.introText} />
            </div>
            <div className="md:w-1/2" id="arvot">
              <div className="bg-brand-secondary p-4 md:p-8">
                <h2 className="section-heading text-left">
                  {pageContent.valuesTitle}
                </h2>
                <RichText
                  className="text-block"
                  value={pageContent.valuesBody}
                />
              </div>
            </div>
          </div>
          <div className="page-width">
            <PersonnelSection people={personnel} />
          </div>
        </section>
      </div>
    </>
  );
}

export async function getServerSideProps({ preview = false }) {
  const [companyInfo, pageContent, personnel] = await Promise.all([
    getCompanyInfo(preview),
    getPageContent("meista", preview),
    getPersonnel(preview),
  ]);

  //console.log(personnel);
  return {
    props: {
      companyInfo,
      pageContent,
      personnel,
      preview,
    },
    //revalidate: siteConfig.revalidate,
  };
}
